<div class="hmn-row__space hmn-grid__gap">
  <div
    *ngFor="let step of steps"
    class="hmn-width__half">
    <span class="hmn-text__7 hmn-color__primary-800">{{ step.translation | translate }}</span>
    <div
      [ngClass]="getCurrentClass(step)"
      class="hmn-background__accent hmn-height__x6"></div>
  </div>
</div>
